import { ConnectedHTMLElement } from "./ConnectedHtmlElement.js";
import { DispatchAction } from "../state/State.js";
import { uiActions } from "../state/UiReducer.js";

/**
 * @name LogModal
 * @class LogModal
 * @extends {ConnectedHTMLElement}
 * @description
 *
 */
export class InitiativeModal extends ConnectedHTMLElement {
  result = undefined;
  evens = 0;
  odds = 0;

  constructor() {
    super();
  }

  /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */
  stateUpdated(newState, oldState) {
    if (newState.ui.showInitiative.show !== oldState.ui.showInitiative.show) {
      this.render();
    }
  }

  registerElementEvents() {
    const player = this.state.ui.showInitiative.player;
    const closeBtn = this.querySelector("#close");
    if (closeBtn !== null) {
      closeBtn.addEventListener("click", () => {
        DispatchAction(uiActions.toggleInitiativeModal, {
          show: false,
          player,
        });
      });
    }
    const rollBtn = this.querySelector("#roll");
    if (rollBtn !== null) {
      rollBtn.addEventListener("click", () => {
        this.rollInitiative();
      });
    }
  }

  rollInitiative() {
    this.evens = 0;
    this.odds = 0;
    for (let i = 0; i < 1000; i++) {
      const roll = Math.floor(Math.random() * 6) + 1;
      if (roll % 2 === 0) {
        this.evens++;
      } else {
        this.odds++;
      }
    }

    this.result = this.evens > this.odds ? 0 : 1;
    this.render();
  }

  render() {
    const player = this.state.ui.showInitiative.player;
    const winnerName =
      this.result !== undefined
        ? this.result % 2 === 0
          ? "Deathstar"
          : "Yoda"
        : "";
    const resultEl =
      this.result !== undefined
        ? `<div>
      <h1>${winnerName} Wins!</h1>
      <p>Winning roll: ${this.evens} vs ${this.odds}</p>
    </div>`
        : "";

    this.innerHTML = `
        <dialog class="z-50 modal ${player === "top" ? "rotate-180" : ""}" id="select-modal" ${this.state.ui.showInitiative.show === true ? "open" : ""}>
          <div class="modal-box">
            <h3 class="font-bold text-2xl mb-2">Roll for initiative?</h3>
            <div class="mb-4">
              <p class="mb-4">Pick Yoda (odd) or Deathstar (even)</p>
              <p class="flex justify-center flex-row items-center">
                <img src="/assets/icons/deathstar.svg" width="64" height="64" alt="Deathstar" class="${winnerName === "Yoda" ? "opacity-50" : ""}">
                <img src="/assets/icons/yoda.svg" width="64" height="64" alt="Yoda" class="${winnerName === "Deathstar" ? "opacity-50" : ""}">
              </p>
            </div>
            ${resultEl}
            <div class="modal-action">
                <button id="roll" class="btn mt-2">Roll initiative!</button>
                <button id="close" class="btn mt-2">Close</button>
            </div>
          </div>
        </dialog>
      </div>
        `;
    this.registerElementEvents();
  }

  connectedCallback() {
    this.render();
  }
}
